export const ReportAttachment = {
  HTML_ATTACHMENT: 'html_attachment',
  PDF_ATTACHMENT: 'pdf_attachment',
  HTML_INLINE: 'html_inline',
  EXCEL: 'excel',
  HTML_WORD: 'html_word',
  POWERPOINT: 'powerpoint',
};

export const SmartEmailFields = {
  // eslint-disable-next-line tap/no-raw-text-js
  ID: 'id',
  // eslint-disable-next-line tap/no-raw-text-js
  NAME: 'name',
};

export const NextSendDatesPayloadKeys = [
  'frequency',
  'send_on_weekday',
  'bi_weekly_start_date',
  'send_on_day_of_the_month',
  'send_on_day_of_the_quarter',
  'send_on_date',
  'data_date_range',
  'data_date_range_preset',
  'data_date_range_preset_offset',
  'data_start_date_custom_date',
  'data_start_date_offset',
  'data_end_date_custom_date',
  'data_end_date_offset',
  'compare_to_previous_period',
  'compare_to_previous_period_type',
  'send_until_date',
  'data_start_date_type',
  'data_end_date_type',
];

export const DataDateType = {
  DATE: 'date',
  OFFSET: 'offset',
};

export const Decision = {
  YES: 'yes',
  NO: 'no',
};

export const DefaultsModel = {
  send_on_weekday: '0',
  send_on_day_of_the_month: '1',
  send_on_day_of_the_quarter: '1',
  data_date_range_preset_offset: '0',
  report_format: ReportAttachment.PDF_ATTACHMENT,
  status: 'active',
  report_content: 'services',
  reporting_profile_id: '1',
  compare_to_previous_period_type: 'prior_period',
  reporting_template_id: '1',
  report_type: 'standard_report',
  frequency: 'monthly',
  data_date_range: 'preset',
  data_date_range_preset: 'lastmonth',
  include_charts_if_available: false,
  enable_ez_login: false,
  skip_attachment: false,
  scheduled_report_user_id: '',
  compare_to_previous_period: false,
  page_id: null,
  report_filename: 'report',
};

export const ReportTypes = {
  report_studio_template: 'rstemplate',
  dashboard: 'dashboard',
  standard: 'standard',
};

export const ScheduledReportRoute = {
  SCHEDULEDREPORTS: 'scheduledreports',
};

export const ScheduledReportPathName = {
  SCHEDULEDREPORTS: 'scheduledreports',
  SCHEDULEDREPORTS_NEW: 'scheduledreports:new',
  SCHEDULEDREPORTFORM: 'scheduledreportform',
};

export const ScheduledReportRecipientType = {
  CLIENT: 'client',
  CLIENT_GROUP: 'client_group',
  CLUSTER: 'cluster',
  INSTANCE_WIDE: 'instance_wide',
  SMART_CAMPAIGN: 'smart_campaign',
};

export const ScheduledReportRecipientTypeValues = {
  client: i18n.$t('Client'),
  client_group: i18n.$t('Client Group'),
  cluster: i18n.$t('Business Unit'),
  smart_campaign: i18n.$t('SmartCampaign'),
  instance_wide: i18n.$t('Instance Wide'),
};

export const ScheduledReportStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  COMPLETE: 'complete',
};

export const ScheduledReportFrequency = {
  FREQUENCY_DAILY: 'daily',
  FREQUENCY_WEEKLY: 'weekly',
  FREQUENCY_BI_WEEKLY: 'bi_weekly',
  FREQUENCY_MONTHLY: 'monthly',
  FREQUENCY_QUARTERLY: 'quarterly',
  FREQUENCY_CUSTOM_DATE: 'custom_date',
};

export const PredefinedFilterName = 'status';
export const IOTool = 'iotool';

export const Freemium = {
  CLIENT: 'client',
  DEFAULT_CLIENT_ID: '1',
  DEFAULT_REPORT_TEMPLATE_ID: '1',
  DEFAULT_DATA_PROFILE_ID: '1',
  SERVICES: 'services',
  STANDARD_REPORT: 'standard_report',
  PDF_ATTACHMENT: 'pdf_attachment',
  REPORT_PDF: 'report_pdf',
};

export const SmartEmailAgents = {
  EXECUTIVE_INSIGHTS: 'executive_insights',
  CAMPAIGN_PERFORMANCE_NARRATIVE: 'campaign_performance_narrative',
  TOP_AND_BOTTOM_PERFORMER_INSIGHTS: 'top_and_bottom_performer_insights',
};
